import React from "react";
import { add, format, differenceInCalendarDays, isFuture } from "date-fns";
import {
  LineChart,
  Line,
  Legend,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer
} from "recharts";

const dateFormatter = date => {
  return format(new Date(date), "dd/MMM");
};

const style = {
    padding: 6,
    backgroundColor: "#000",
    border: "1px solid #ccc"
  };
/**
 * get the dates between `startDate` and `endSate` with equal granularity
 */
const getTicks = (startDate, endDate, num) => {
  const diffDays = differenceInCalendarDays(endDate, startDate);

  let current = startDate,
    velocity = Math.round(diffDays / (num - 1));

  const ticks = [startDate.getTime()];

  for (let i = 1; i < num - 1; i++) {
    ticks.push(add(current, { days: i * velocity }).getTime());
  }

  ticks.push(endDate.getTime());
  return ticks;
};

/**
 * Add data of the date in ticks,
 * if there is no data in that date in `data`.
 *
 * @param Array<number> _ticks
 * @param {*} data
 */

const CustomTooltip = props => {
    const { active, payload } = props;
    if (active) {
      const currData = payload && payload.length ? payload[0].payload : null;
      return (
        <div className="area-chart-tooltip" style={style}>
          <p>
            {currData ? format(new Date(currData.date), "yyyy-MM-dd") : " -- "}
          </p>
          <p>
            {"value : "}
            <em>{currData ? currData.weight : " -- "}</em>
          </p>
        </div>
      );
    }
  
    return null;
  };
  

export const GrowthChart = ({ dataPoints, name, startDate, endDate }) => {

  const domain = [dataMin => dataMin, () => endDate.getTime()];
  const ticks = getTicks(startDate, endDate, 5);
  const filledData = (dataPoints);
  return (
    <div>
      <p className="text-center">{name}'s Growth</p>
      <ResponsiveContainer width="90%" height={400}>
        <LineChart
          height={400}
          data={filledData}
          margin={{
            top: 10,
            right: 0,
            bottom: 10,
            left: 0
          }}
        >
          <XAxis
            dataKey="date"
            hasTick
            scale="time"
            tickFormatter={dateFormatter}
            type="number"
            domain={domain}
            ticks={ticks}
          />
          <YAxis tickCount={7} hasTick={true} />
          <CartesianGrid strokeDasharray="3 3" />
          <Tooltip content={<CustomTooltip />} />
          <Line
            type="monotone"
            dataKey="weight"
            stroke="#2bc3c3"
            fill="#2bc3c3"
            fillOpacity={0.9}
          />
          <Legend />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

